import React from "react";

const ProgressBar = (props) => {
  return (
    <div className="progress">
      <div
        id={"labeldiv-" + props.id}
        style={{
          display: "none",
        }}
      >
        {props.arialabel}
      </div>
      <div
        role="progressbar"
        className="progress-bar bg-secondary progress-bar-animated progress-bar-striped"
        aria-label={props.arialabel}
        aria-labelledby={"labeldiv-" + props.id}
        style={{
          width: props.valuenow + "%",
        }}
      >
        <div className="progress-percentage pt-3">{props.label.toString()}</div>
      </div>
    </div>
  );
};

export default ProgressBar;
